import {
  GreenGreen70,
  Image,
  Inspector,
  Box,
  Flex
} from '@sequencehq/core-components'
import { goCardlessIntegrationConfig } from '../goCardless.integration.config'
import { FC, ReactNode } from 'react'
import { useIntegrationActive } from 'Integrations/utils/useIntegrationActive'
import { SmallIcon } from 'Integrations/integrationsConfig/common/SmallIcon'
import addGoCardlessIcon from './addGoCardlessIcon.svg'
import addGoCardlessIconInactive from './addGoCardlessIconInactive.svg'
import { NotConnectedItemContent } from 'Integrations/integrationsConfig/common/NotConnectedItemContent'

const GoCardlessNotConnected = () => (
  <Inspector.IconItem
    data-testid="gocardless.inspector.item"
    tooltip="GoCardless"
    icon={<Image src={addGoCardlessIconInactive} height="30px" width="30px" />}
    activeIcon={<Image src={addGoCardlessIcon} height="30px" width="30px" />}
    content={
      <NotConnectedItemContent
        serviceName={goCardlessIntegrationConfig.title}
        serviceDescription={goCardlessIntegrationConfig.description}
        logo={
          <Image
            src={goCardlessIntegrationConfig.smallLogoUrl}
            height="24px"
            width="24px"
          />
        }
        service="GoCardless"
        data-testid="gocardless.inspector.content.notConnected"
      />
    }
  />
)

export const GoCardlessInspectorItem: FC<{
  alwaysShow?: boolean
  enabled?: boolean
  children: ReactNode
}> = props => {
  const integrationActive = useIntegrationActive('GoCardless')

  if (!integrationActive) {
    return <GoCardlessNotConnected />
  }

  return (
    <Inspector.IconItem
      id="gocardless.inspector.item"
      data-testid="gocardless.inspector.item"
      tooltip="GoCardless"
      icon={<GoCardlessIconWithBadge enabled={props.enabled} />}
      content={
        <Inspector.Content
          data-testid="gocardless.inspector.content"
          title="GoCardless"
          icon={<GoCardlessIcon />}
        >
          <Flex flexDirection="column" gap="16px">
            {props.children}
          </Flex>
        </Inspector.Content>
      }
    />
  )
}

export const GoCardlessIcon: FC<{ onClick?: () => void }> = ({ onClick }) => (
  <SmallIcon url={goCardlessIntegrationConfig.smallLogoUrl} onClick={onClick} />
)

const GoCardlessIconWithBadge: FC<{ enabled?: boolean }> = ({ enabled }) => (
  <Box position="relative">
    <GoCardlessIcon />
    {enabled && (
      <Box
        data-testid="gocardless.inspector.item.badge"
        position="absolute"
        top="-4px"
        right="-4px"
        height="8px"
        width="8px"
        borderRadius="full"
        backgroundColor={GreenGreen70}
        boxShadow="0 0 0 1.5px white"
      />
    )}
  </Box>
)
